import React from "react";

/**
 * Iter-253 §UX: subtle green dot next to any form-field label that was
 * auto-filled by the plate-lookup widget. Disappears the moment a seller
 * edits that field (the dot represents "not yet confirmed").
 *
 * Kept tiny and non-blocking — pure visual trust signal, no aria overlay
 * beyond the label text so screen readers get the same info via the
 * title attribute.
 */
export default function PrefilledDot({ label = "Auto-filled" }) {
  return (
    <span
      data-testid="prefilled-dot"
      title={`${label} — edit if needed`}
      aria-label={label}
      className="inline-flex items-center gap-1 ml-1.5 align-middle"
    >
      <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 shadow-[0_0_0_2px_rgba(16,185,129,0.15)]" />
    </span>
  );
}
